import type { ElementStatus, ArsenalType } from '../client/IvtHubClient';

/**
 * 八要素的名称（按 elementNumber 1-8 排序）。复刻 prototype 的 ELEMENT_LABELS
 * (app.html:2399)，其 Object.keys 顺序 painpoint=1..reference=8 与后端
 * SQL_ELEMENTS_JSONB 投影顺序 (CR-282339547) 完全一致。后端 Element 只返回
 * elementNumber + status + content（无标题），名称在前端按编号映射。
 */
export const ELEMENT_NAMES: Record<number, string> = {
  1: '客户痛点 Painpoint',
  2: '目标画像 Audience',
  3: 'AWS 撬动点 Leverage',
  4: '竞争优势 Competitive Edge',
  5: '切入场景 Entry Scenario',
  6: '成功标准 Success Metric',
  7: '异议地图 Objection Map',
  8: '参考案例 References',
};

/** 一个要素是否“已编码”（有内容且非 EMPTY）。 */
export function isElementFilled(status?: ElementStatus, content?: string): boolean {
  return status !== 'EMPTY' && !!content;
}

/** arsenal type → emoji 图标（复刻 prototype typeIcons，键改成大写枚举）。 */
export const ARSENAL_ICON: Record<ArsenalType, string> = {
  ARD: '📄',
  FIRST_CALL_DECK: '📊',
  DEMO_VIDEO: '🎬',
  UAT_DOC: '✅',
  ARCHITECTURE: '🏗️',
  DEPLOYMENT_GUIDE: '📦',
  HIGHSPOT: '🔗',
  ASSET_CARD: '🪪',
  BOM: '💰',
  ASSET_TAG: '🏷️',
  ASSET_PAGE: '📝',
  BLOG: '📰',
  CASE_STUDY: '🏆',
  DEMO_AGENT: '🤖',
  ISA_RECIPE: '⚙️',
  SALES_PLAY: '🎯',
  DOCUMENT: '📋',
};

export function arsenalIcon(type?: ArsenalType): string {
  return type ? ARSENAL_ICON[type] ?? '📎' : '📎';
}
